import React from 'react'
import image from '../assets/Profile.jpg'
const AboutImage = () => {
  return (
    <div className=' text-white mx-auto flex max-w-2xl items-center justify-between  p-4 lg:px-8 mt-24'>
        <div className=" w-full bg-red-700 p-9 h-[700px] rounded-3xl"
         style={{
            backgroundImage: ` url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'top',
          }}>
        </div>
    </div>
  )
}

export default AboutImage